import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { arrayToTree, getAllParentIds } from 'utils/tree';
import useUniqueId from 'hooks/useUniqueId';
import Box from 'components/Box';
import Button from 'components/Button';
import Card from 'components/Card';
import EmptyStateController from 'components/EmptyStateController';
import StickyButtonPanel from 'components/StickyButtonPanel';
import { TreeView, TreeViewItem } from 'components/TreeView';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
export default function MoveModal(_ref) {
  var itemsToMove = _ref.itemsToMove,
    providedFolders = _ref.folders,
    onClose = _ref.onClose,
    onMoveItems = _ref.onMoveItems,
    isMoving = _ref.isMoving,
    initialTargetFolderId = _ref.initialTargetFolderId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var rootFolder = {
    id: null,
    name: t('top_level')
  };
  var sortedFolders = _toConsumableArray(providedFolders).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  var folders = [rootFolder].concat(_toConsumableArray(sortedFolders));
  var defaultFolder = folders.find(function (folder) {
    return folder.id === initialTargetFolderId;
  });
  var _useState = useState(defaultFolder),
    _useState2 = _slicedToArray(_useState, 2),
    targetFolder = _useState2[0],
    setTargetFolder = _useState2[1];
  var wasSelectionChanged = initialTargetFolderId !== (targetFolder === null || targetFolder === void 0 ? void 0 : targetFolder.id);
  function submit(_x) {
    return _submit.apply(this, arguments);
  }
  function _submit() {
    _submit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            e.stopPropagation();
            if (!wasSelectionChanged) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return onMoveItems(targetFolder);
          case 5:
            onClose();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submit.apply(this, arguments);
  }
  var foldersAsTree = arrayToTree(folders);
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    overflow: "visible",
    as: "form",
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    sticky: true,
    title: t('actions_move'),
    titleId: titleId,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    z: "flat",
    borderTop: "thin",
    role: "group",
    "aria-labelledby": titleId,
    mb: "m"
  }, /*#__PURE__*/React.createElement(EmptyStateController, {
    isEmpty: folders.length === 0
  }, /*#__PURE__*/React.createElement(TreeView, {
    items: foldersAsTree,
    getInitialExpandedItemIds: function getInitialExpandedItemIds() {
      return getAllParentIds(folders, itemsToMove.at(0));
    }
  }, function (_ref2) {
    var item = _ref2.item,
      hasChildren = _ref2.hasChildren,
      nestingLevel = _ref2.nestingLevel,
      isExpanded = _ref2.isExpanded,
      onToggleIsExpanded = _ref2.onToggleIsExpanded;
    var isInitialFolder = initialTargetFolderId === item.id;
    var isFolderBeingMoved = !!itemsToMove.find(function (itemToMove) {
      return itemToMove.id === item.id;
    });

    // Only expand folders which are not being moved and which have children
    var isExpandable = !isFolderBeingMoved && hasChildren;
    var subtitle = isInitialFolder ? t('current_location') : isFolderBeingMoved ? t('this_item_will_be_moved') : undefined;
    return /*#__PURE__*/React.createElement(TreeViewItem, {
      key: item.id,
      allowMultiSelection: false,
      label: item.name,
      subtitle: subtitle,
      nestingLevel: nestingLevel,
      isExpandable: isExpandable,
      isExpanded: isExpanded,
      isDisabled: isFolderBeingMoved,
      isSelected: item.id === (targetFolder === null || targetFolder === void 0 ? void 0 : targetFolder.id),
      onSelect: function onSelect() {
        return setTargetFolder(item);
      },
      onToggleExpand: function onToggleExpand() {
        return onToggleIsExpanded(item.id);
      }
    });
  }))), /*#__PURE__*/React.createElement(StickyButtonPanel, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: wasSelectionChanged ? 'primary' : 'default',
    isLoading: isMoving
  }, wasSelectionChanged ? t('actions_move_to_location', {
    location: targetFolder === null || targetFolder === void 0 ? void 0 : targetFolder.name
  }) : t('actions_keep_in_current_location')))));
}